import { render } from "./WhatsAppModalSidebarRightChatMessageContainerMessagesText.vue?vue&type=template&id=d68d2460"
import script from "./WhatsAppModalSidebarRightChatMessageContainerMessagesText.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRightChatMessageContainerMessagesText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__